module.exports = __webpack_public_path__ + "static/media/awards_13.b52582a8.jpg";